function show(element: HTMLElement, display?: string): void {
    element.style.display = display ?? '';
}

// ----------------------------------------------------------------------------

export default show;
